import loadable from '@loadable/component';
import { WithLazyHydration } from '../../WithLazyHydration';

const ContentLoadable = loadable(() => import('./Content'), {
  resolveComponent: components => components.Content
});

export const Content = WithLazyHydration(ContentLoadable, {
  name: 'Content'
});
